import './SearchResults.scss';

/* eslint-disable import/no-cycle */
import React from 'react';
import { SearchProductResult } from 'types/index';
import { checkStores } from 'utility/utility';
import ProductPrice from './ProductPrice';

export default function SearchResults({
  maxListPrice,
  minListPrice,
  maxOfferPrice,
  minOfferPrice,
  mapPriceIndicator,
  priceIndicator,
  name,
  partNumber,
  seoUrl,
  thumbnail,
}: SearchProductResult) {
  return (
    <div key={partNumber} className="dsg-search-results hmf-m-xxxs">
      <a
        className="dsg-search-link hmf-p-xxs"
        data-testid="sayt-product-card"
        href={checkStores(seoUrl)}>
        <div className="dsg-search-thumbnail">
          <img src={thumbnail} alt="product thumbnail" />
        </div>
        <div className="product-information hmf-mt-xs">
          <div className="product-name hmf-body-l hmf-body-bold-m hmf-mb-xxxs">{name}</div>
          <ProductPrice
            maxListPrice={maxListPrice}
            minListPrice={minListPrice}
            maxOfferPrice={maxOfferPrice}
            minOfferPrice={minOfferPrice}
            mapPriceIndicator={mapPriceIndicator}
            priceIndicator={priceIndicator}
          />
        </div>
      </a>
    </div>
  );
}
